export default __webpack_public_path__ + "static/media/playstore.1e2f7839.png";